import { API_URL, ApiError } from "@/lib/api/client";

export interface AuthUser {
  id: number;
  name: string;
  email: string;
  administrator?: boolean;
  [key: string]: unknown;
}

async function parseUser(res: Response): Promise<AuthUser> {
  return (await res.json()) as AuthUser;
}

export const authService = {
  async login(email: string, password: string): Promise<AuthUser> {
    const res = await fetch(`${API_URL}/api/session`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      body: new URLSearchParams({ email, password }).toString(),
    });

    if (!res.ok) {
      throw new ApiError(
        res.status === 401
          ? "E-mail ou senha inválidos."
          : `Erro ${res.status} ao autenticar`,
        res.status,
      );
    }

    return parseUser(res);
  },

  // GET /api/session recupera a sessão atual a partir do cookie.
  // Sem sessão válida, o servidor responde 401 ou 404 (não é um erro real).
  async getSession(): Promise<AuthUser | null> {
    const res = await fetch(`${API_URL}/api/session`, {
      method: "GET",
      credentials: "include",
      headers: { Accept: "application/json" },
    });

    if (res.status === 401 || res.status === 404) return null;
    if (!res.ok) {
      throw new ApiError(`Erro ${res.status} ao verificar sessão`, res.status);
    }

    return parseUser(res);
  },

  async logout(): Promise<void> {
    await fetch(`${API_URL}/api/session`, {
      method: "DELETE",
      credentials: "include",
    });
  },
};
